import React from 'react';
import { css } from '@emotion/css';
import { Colors } from '../styles/colors';

interface IStepIndicator {
  totalSteps: number;
  currentStep: number;
}

export const StepIndicator = (props: IStepIndicator): JSX.Element => {
  const calculateWidth = () => {
    const width = Math.round((100 / props.totalSteps) * props.currentStep);
    return `${width}%`;
  };

  return (
    <div
      className={stepIndicatorStyle(calculateWidth())}
      role="progressbar"
      aria-valuemin={0}
      aria-valuemax={props.totalSteps}
      aria-valuenow={props.currentStep}
    ></div>
  );
};

const stepIndicatorStyle = (width: string) => css`
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 3px;
  transform: scaleX(${parseFloat(width) / 100});
  transform-origin: left center;
  transition: transform 400ms cubic-bezier(0.2, 0, 0, 1);
  background: ${Colors.CAPRI_BLUE};
  border-radius: 0 999px 999px 0;
  z-index: 60;
`;
